import React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';

import type {GetWorkOsInformation_workOs_directorySync as DirectorySync} from 'nutshell-graphql-types';

type Props = {
    directorySync: DirectorySync | null | undefined;
    handleQueueDirectorySync: () => void;
    isQueueDirectorySyncLoading: boolean;
    queueDirectorySyncError: string | null | undefined;
};

export function DirectorySyncSync(props: Props) {
    const [showStatusText, setShowStatusText] = React.useState<boolean>(false);
    const queueDirectorySyncError = props.queueDirectorySyncError !== null;

    const handleQueueDirectorySync = () => {
        setShowStatusText(true);
        props.handleQueueDirectorySync();
    };

    return (
        <div className='flex flex-dir-col gap-8'>
            <Body size='small' isBold={true}>
                Sync your directory
            </Body>
            <StackLegacy isHorizontal={true} spacing={8} alignCenter={true}>
                <SaveButton
                    variant='primary'
                    size='small'
                    // @ts-expect-error
                    onClick={handleQueueDirectorySync}
                    tooltipText={
                        !props.directorySync || !props.directorySync.isConfigured
                            ? 'Configure Directory Sync first'
                            : 'May take some time to complete'
                    }
                    disabled={!props.directorySync || !props.directorySync.isConfigured}
                    isSaving={props.isQueueDirectorySyncLoading}
                    resetOnComplete={false}
                    buttonText='Sync'
                    savingText='Sync Started'
                    successText='Sync Started'
                    errorSaving={queueDirectorySyncError}
                />
                {showStatusText && (
                    <Body size='small' color='medium' as='div'>
                        {queueDirectorySyncError
                            ? 'Error syncing directory, try again later'
                            : 'May take some time to complete, check back later'}
                    </Body>
                )}
            </StackLegacy>
            <StackLegacy isHorizontal={true} spacing={4}>
                <Body size='small' color='medium'>
                    Last synced:
                </Body>
                {props.directorySync && props.directorySync.lastSyncTime ? (
                    <FormattedTimestamp
                        datetime={props.directorySync.lastSyncTime}
                        format={FormattedTimestamp.formats.longMonthDayYearWithTime}
                    />
                ) : (
                    <Body size='small' color='medium'>
                        {props.directorySync && props.directorySync.isConfigured
                            ? 'Never'
                            : 'Not configured'}
                    </Body>
                )}
            </StackLegacy>
        </div>
    );
}
